<template>
  <div v-if="hasProductRecommendations" class="product-recommendations">
    <div class="product-recommendations__header container">
      <h2 class="product-recommendations__title">More For You</h2>
    </div>
    <div class="photos">
      <PhotoTile
        v-for="product in productRecommendations"
        :key="product.id"
        :product="product"
        :flat-lays="flatLays"
      />
    </div>
  </div>
</template>

<script>
import productRecommendations from "@/graphql/queries/ProductRecommendations.gql";
import PhotoTile from "@/components/PhotoTile.vue";
export default {
  name: "ProductRecommendations",
  components: {
    PhotoTile,
  },
  props: {
    productId: {
      type: String,
      required: true,
    },
    flatLays: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasProductRecommendations() {
      return !!this.productRecommendations?.length;
    },
  },
  apollo: {
    productRecommendations: {
      query: productRecommendations,
      variables() {
        return {
          productId: this.productId,
        };
      },
      result({ data }) {
        window.productRecommendations = data.productRecommendations;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.product-recommendations {
  padding: 60px 0 0;
  margin-bottom: 60px;

  @include respond-above(md) {
    padding: 80px 0 0;
    margin-bottom: 80px;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 10px;
    padding: 0 10px;

    @include respond-above(md) {
      padding: 0 20px;
    }
  }

  &__title {
    text-transform: uppercase;
    font-size: 18px;
    font-weight: normal;

    @include respond-above(md) {
      font-size: 30px;
    }
  }

  &__link {
    font-size: 8px;
    text-decoration: none;
    text-transform: uppercase;
    color: $color-dark;
    font-weight: 600;

    @include respond-above(md) {
      font-size: 10px;
    }
  }
}

.photos {
  display: flex;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;

  & > * {
    flex: 1 0 45%;
    margin-right: 2px;
    max-width: 348px;
  }
}
</style>
